import { render, staticRenderFns } from "./CourseAssign.vue?vue&type=template&id=a59c9842&scoped=true&"
import script from "./CourseAssign.vue?vue&type=script&lang=js&"
export * from "./CourseAssign.vue?vue&type=script&lang=js&"
import style0 from "./CourseAssign.vue?vue&type=style&index=0&id=a59c9842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59c9842",
  null
  
)

export default component.exports